import React, {useContext, useState, useCallback, useRef, useEffect} from 'react'
import {useSelector} from "react-redux";
import PropTypes from 'prop-types'
import Slider from 'react-rangeslider'
import Tooltip from '../../../../components/shared/tooltip'

import {SelectHostingContext, UPDATE_CONFIG} from "../state"

import {
  getCycle,
  getPriceByBillingCycleName
} from "../../../../utilities/function/billingCycle"

import {
  getAttributes
} from "../../../../utilities/function/configuration"


const SelectHostingSlider = (props) => {
  const {initialValue,item} = props

  const [val,setVal] = useState(initialValue)

  const [openDropdown,setDropdown] = useState(false)

  const {state,dispatch} = useContext(SelectHostingContext)

  const {viewport} = useSelector(state=>({
    viewport: state.app.viewport
  }))

  const getOptions = useCallback(() => {
    if(item && item.options){
      return item.options
    }
    return []
  },[item])

  const getSelectedOption = useCallback(()=>{
    if(getOptions() && getOptions()[val]){
      return getOptions()[val]
    }
    return null
  },[val,getOptions])

  const getLabels = () =>{
    const options = getOptions()
    if(options && options.length){
      const labels = {}
      options.forEach((item,index)=>{
        labels[index] = item.name
      })
      return labels
    }
    return {}
  }

  const getMax =() =>{
    return getOptions() && getOptions().length -1 ? getOptions().length-1 : 0
  }

  const onChangeCompleteCallback = useCallback(()=>{
      const selectedOption = getSelectedOption()
      if(state && state.config && state.config.length){
        const newConfig = state.config
        Object.keys(state.config).forEach((index)=>{
           if(newConfig[index].config_id && newConfig[index].config_id ===item.id){
             newConfig[index].option_id = selectedOption.id
           }
        })
        dispatch({
          type: UPDATE_CONFIG,
          config: newConfig
        })
      }
  },[state,dispatch,getSelectedOption,item])

  const sliderRef = useRef(null)

  const initRef  = useRef(null)

  const prevViewport = useRef(null)

  const dropdownRef= useRef(null)

  const initCallback = useCallback(()=>{
    if(prevViewport.current!== viewport){
      if(!initRef.current && sliderRef.current && sliderRef.current.slider){
        const {slider} = sliderRef.current
        const currentClassname = slider.className
        slider.className = currentClassname + " primary-background-1-15"
        if(slider.children && slider.children.length){
          for (const item of slider.children) {
            if(item.className==="rangeslider__fill"){
              item.className = "rangeslider__fill primary-background-1-100"
            }
            if(item.className==="rangeslider__handle"){
              item.className = "rangeslider__handle primary-border-1-100"
            }
          }
        }
      }
      prevViewport.current = viewport
    }

  },[sliderRef,initRef,viewport])

  const onValueChangeCallback = useCallback(()=>{
    const {config} = state
    const {id} = item
    if(config && config.length){
      const selected = config.find(i=>i.config_id===id)
      if(getAttributes(item) ){
        const {options} = getAttributes(item)
        let selectedIndex = 0
        options.forEach((item,index)=>{
          if(selected.option_id===item.id){
            selectedIndex = index
          }
        })
        setVal(selectedIndex)
      }
    }
  },[state,item])

  useEffect(()=>{
    initCallback()
    onValueChangeCallback()
  },[initCallback,onValueChangeCallback])

  //render config details
  const renderConfigDetails = () => {
    if(item && item.name && item.description){
      const{description,name} = item
      return (
          <div className={`of-select-hosting-slider__details of-select-hosting-slider-details`}>
            <div className={`of-select-hosting-slider-details__name text-font-1-100`}>{name}</div>
            <Tooltip className={`select-hosting-slider-details__tooltip`} description={description} />
          </div>
      )
    }
    return (<></>)
  }

  //render config value
  const renderConfigValue = () => {
    const selectedOption = getSelectedOption()
    const renderUnit = () => {
      if(item && item.name){
        return (<span className={'of-select-hosting-slider__unit'}>{item.name}</span>)
      }
      return (<></>)
    }
    if(selectedOption && selectedOption.name){
      return (
          <div className={`of-select-hosting-slider__value primary-font-1-100`}>{selectedOption.name}{renderUnit()}</div>
      )
    }
    return(<></>)
  }

  //render config price
  const renderConfigPrice = () => {
    const selectedOption = getSelectedOption()
    if(selectedOption && selectedOption.price){
      const selectedPrice = getPriceByBillingCycleName(selectedOption.price,'Monthly')
      if(selectedPrice){
        return (<div className={`of-select-hosting-slider__price text-font-3-100`}>${selectedPrice.price}{getCycle('Monthly')}</div>)
      }
    }
    return (<></>)
  }

  const renderSliderComponent= () => {
    return (
        <div className={`of-select-hosting-slider`}>
          <div className={`of-select-hosting-slider__top`}>
            {renderConfigDetails()}
            {renderConfigValue()}
            {renderConfigPrice()}
          </div>
          <div className={`of-select-hosting-slider__bottom text-font-3-100`}>
            <Slider
                min={0}
                max={getMax()}
                step={1}
                value={val}
                tooltip={false}
                labels={getLabels()}
                onChange={(val)=>{
                  setVal(val)
                }}
                onChangeComplete={onChangeCompleteCallback}
                ref={sliderRef}
            />
          </div>
        </div>
    )
  }

  const clickAway = (e) => {
    if(e.target !== dropdownRef.current && (dropdownRef.current && !dropdownRef.current.contains(e.target))){
      setDropdown(false)
      document.removeEventListener("click",this)
    }

  }

  //for mobile
  const renderDropdownComponent = () => {
    const selectedOption = getSelectedOption()
    const onClickDropdown = ()=>{
      setDropdown(!openDropdown)
      document.addEventListener("click",clickAway)
    }
    const optionsList = getOptions()
    const renderList = () =>{
      if(optionsList && optionsList.length){
        return optionsList.map((option, index) => {
          const onClick = () => {
            setDropdown(false)
            const newConfig = state.config
            if (newConfig && newConfig.length) {
              newConfig.forEach((conf, i) => {
                if (conf.config_id === item.id) {
                  newConfig[i].option_id = option.id
                }
              });
              dispatch({
                type: UPDATE_CONFIG,
                config: Object.assign([], newConfig)
              })
            }
          }
          return (
            <div onClick={onClick} key={index} className={`of-select-hosting-slider-dropdown__option text-font-3-100`}>
              <strong>{option.name}</strong><span>{item.name}</span>
            </div>
          )
        })
      }
    }
    return (<div className={`of-select-hosting-slider-mobile`}>
      <div className={'of-select-hosting-slider-mobile__left'}>
        <div ref={dropdownRef} onClick={onClickDropdown} className={`of-select-hosting-slider-dropdown${openDropdown?' of-select-hosting-slider-dropdown--open':''}`}>
          <div className={'of-select-hosting-slider-dropdown__top'}>
            <div className={'of-select-hosting-slider-dropdown__selected'}>
              <div className={'of-select-hosting-slider-dropdown__label primary-font-1-100'}>
                <strong>{selectedOption.name}</strong><span>{item.name}</span>
              </div>
              <div className={'of-select-hosting-slider-dropdown__icon text-font-3-100'}>
                <div className={'icon-of-arrow icon'} />
              </div>
            </div>
          </div>
          <div className={'of-select-hosting-slider-dropdown__bottom'}>
            {renderList()}
          </div>
        </div>
      </div>
      <div className={'of-select-hosting-slider-mobile__right'}>
        {renderConfigPrice()}
      </div>
    </div>)
  }

  if(viewport==="xs"){
   return (renderDropdownComponent())
  }



  return (renderSliderComponent())
}

SelectHostingSlider.propTypes = {
  initialValue: PropTypes.number,
  item: PropTypes.object,
}

export default SelectHostingSlider
